import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Routes from 'Routes';
import Header from 'Header';
import './index.less';

class FeeQuery extends Component {
  _navBarLeftClick = () => {
    this.props.router.goBack();
  };

  render() {
    return (
      <div className="feeQueryPage">
        <header>
          <Header
            onLeftClick={this._navBarLeftClick}
            title={Routes.ticket.child.feeQuery.name}
          />
        </header>
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(FeeQuery);



// WEBPACK FOOTER //
// ./src/routes/routes/feeQuery/components/FeeQueryContainer/index.js